/**
 * @generated SignedSource<<285102cf658e87f8407f97561032d73b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type DeleteCartBundleInput = {
  bundleId: string;
  cartId: string;
  channel: CartChannel;
};
export type useDeleteBundleMutation$variables = {
  input: DeleteCartBundleInput;
};
export type useDeleteBundleMutation$data = {
  readonly deleteBundle: {
    readonly message: string;
    readonly code: number;
    readonly success: boolean;
  };
};
export type useDeleteBundleMutation = {
  variables: useDeleteBundleMutation$variables;
  response: useDeleteBundleMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteBundleResponse",
    "kind": "LinkedField",
    "name": "deleteBundle",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteBundleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDeleteBundleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "efe3bc0b8ab37637978e36e938f09c5c",
    "id": null,
    "metadata": {},
    "name": "useDeleteBundleMutation",
    "operationKind": "mutation",
    "text": "mutation useDeleteBundleMutation(\n  $input: DeleteCartBundleInput!\n) {\n  deleteBundle(input: $input) {\n    message\n    code\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "096e2ebb76855861cf2c6d34bb83d28a";

export default node;
